import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  componentName?: string;
}

interface State {
  hasError: boolean;
  errorMessage: string;
  errorStack: string;
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    errorMessage: '',
    errorStack: ''
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, errorMessage: error.message, errorStack: error.stack || '' };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error(`🔴 CRASH IN ${this.props.componentName || 'COMPONENT'}:`, error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div className="p-6 bg-red-900/50 border border-red-500 rounded-xl m-4 text-white font-mono text-sm max-w-4xl mx-auto mt-10">
          <h2 className="text-xl font-bold text-red-400 mb-2">🛑 SYSTEM-CRASH ABGEFANGEN ({this.props.componentName})</h2>
          <p className="mb-4">Eine fehlerhafte oder fehlende Variable hat das UI zerstört. Die App bleibt aber stabil.</p>
          <div className="bg-black/80 p-4 rounded overflow-auto border border-white/10">
            <p className="text-red-300 font-bold mb-2">Fehler: {this.state.errorMessage}</p>
            <pre className="text-gray-400 text-[10px] whitespace-pre-wrap leading-relaxed">{this.state.errorStack}</pre>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
